/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const customerArchiveBodyExpectedCustomerVersionExclusiveMin = 0;
export const customerArchiveBodyExpectedCustomerVersionMax = 9007199254740991;

export const CustomerArchiveBody = zod.object({
  expectedCustomerVersion: zod
    .int()
    .gt(customerArchiveBodyExpectedCustomerVersionExclusiveMin)
    .max(customerArchiveBodyExpectedCustomerVersionMax),
  confirmed: zod.literal(true),
});

export type CustomerArchiveBody = zod.input<typeof CustomerArchiveBody>;
export type CustomerArchiveBodyOutput = zod.output<typeof CustomerArchiveBody>;
